import { useContext, useState, useEffect } from 'react'
import { useConfirm } from 'material-ui-confirm'
import { Context } from '../../../utils/context'
import { format } from 'react-string-format'
import useTableIcons from '../../useTableIcons'
import { Strings } from '../../../assets/res/en'
import { groupsEndPoints } from '../../../utils/endpoints'
import { modules } from '../../../utils/config'
function useGroups() {
    const { axios, authData, permissions } = useContext(Context)
    const authToken = `Bearer ${authData.token}`
    const { tableIcons } = useTableIcons()
    const confirm = useConfirm()
    const [groupPermission, setGroupPermission] = useState({})
    const [groups, setGroups] = useState([])
    const [sgroups, setSearchGroups] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [filters, setFilters] = useState([])
    const [searchData, setSearchData] = useState({
        sGroup: ""
    })
    //check permission changes
    useEffect(() => {
        if (permissions && permissions.length > 0) {
            let grPermission = permissions.find(p => p.moduleId === modules.groups.id)
            setGroupPermission(grPermission)
        }
    }, [permissions])

    const handleChange = (name, value) => {
        setSearchData(prevData => ({
            ...prevData,
            [name]: value
        }))
    }

    const handleSearch = () => {
        let searchFilter = searchData.sGroup.trim()
        if (searchFilter) {
            setFilters([
                {
                    name: "sGroup",
                    value: searchFilter,
                    remove: resetData
                }
            ])
            
            setGroups(sgroups.filter(g => g.description.toLowerCase().includes(searchFilter.toLowerCase())))
        }
        else resetData()
    }
    const resetData = () => {
        setSearchData({
            sGroup: ""
        })
        setFilters([])
        getAllGroups()
    }
    const searchOptions = {
        title: Strings.SEARCH_GROUPS_TITLE,
        spacing: 2,
        searchItems: [
            {
                name: "sGroup",
                label: Strings.SEARCH_GROUPS_TITLE,
                type: 'search',
                defaultValue: searchData["sGroup"],
                onChange: handleChange
            }
        ],
        handleSearch
    }

    const getAllGroups = () => {
        setIsLoading(true)
        axios.get(groupsEndPoints.getAll,
            { headers: { 'Authorization': authToken } })
            .then(res => {
                if (res.data.success) {
                    const { data } = res.data
                    console.log(data)
                    setGroups(data)
                    setSearchGroups(data)
                }
            })
            .catch(err => err)
            .finally(() => setIsLoading(false))
    }
    const actions = [
        rowData => ({
            icon: rowData.status === 0 ? tableIcons.CheckBoxBlank : tableIcons.CheckBox,
            tooltip: groupPermission.update ? rowData.status === 0 ? 'Activate this Group' : 'Deactivate this Group' : 'Permission Denied',
            disabled: !groupPermission.update,
            onClick: (event, rowData) => new Promise((resolve) => {
                let cnfDesc = rowData.status === 0 ? `This will activate group ${rowData.description}` :
                    `This will deactivate group ${rowData.description}`
                confirm({ description: cnfDesc })
                    .then(() => {
                        let url = rowData.status === 0 ? groupsEndPoints.activateGroupById : groupsEndPoints.deActivateGroupById
                        axios.put(
                            format(url, rowData.idGroup),
                            {},
                            { headers: { 'Authorization': authToken } })
                            .then(res => {
                                if (res.data.success) {
                                    const dataUpdate = [...groups]
                                    const index = rowData.tableData.id
                                    dataUpdate[index] = res.data.data
                                    setGroups([...dataUpdate])
                                    resolve()
                                }
                            })
                    })
            })
        })
    ]
    const editOptions = {
        isEditable: () => groupPermission.update,
        onRowAdd: groupPermission.create === true ?
            newData =>
                new Promise((resolve) => {
                    axios.post(
                        groupsEndPoints.addGroup,
                        newData,
                        { headers: { 'Authorization': authToken } })
                        .then(res => {
                            if (res.data.success) {
                                setGroups([newData, ...groups])
                                resolve()
                            }
                        })
                })
            : undefined,
        onRowUpdate: (newData, oldData) =>
            new Promise((resolve) => {
                axios.put(
                    format(groupsEndPoints.updateGroupById, newData.idGroup),
                    newData,
                    { headers: { 'Authorization': authToken } })
                    .then(res => {
                        if (res.data.success) {
                            const dataUpdate = [...groups]
                            const index = oldData.tableData.id
                            dataUpdate[index] = newData
                            setGroups([...dataUpdate])
                            resolve()
                        }
                    })
            })
    }
    return {
        editOptions,
        groups,
        isLoading,
        getAllGroups,
        searchOptions,
        actions,
        filters,
        groupPermission
    }
}

export default useGroups;